import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Container } from "../styles/styles";
import {
  PrimaryColor,
  SecondaryColor,
  TextColor,
  TextColorLight,
  BackgroundColor,
  BackgroundColorLight,
  Accent,
  ErrorComponent,
  Border,
  Green,
  Blue,
} from "../styles/global";
import { BackBar } from "../styles/global";
import { ContentSection, Content } from "../styles/styles";
import { toast } from "react-toastify";

import breakpoints from "../styles/breakpoints";
import { styles } from "../pages/home/styles";
import { SvgUser } from "../assets/icons";
import coin1 from "../assets/icons/moeda-1.svg";
import coin5 from "../assets/icons/moeda-5.svg";
import coin10 from "../assets/icons/moeda-10.svg";
import coin50 from "../assets/icons/moeda-50.svg";
import coin100 from "../assets/icons/moeda-100.svg";
import { FaRegUserCircle } from "react-icons/fa";
import logo from "../assets/icons/logo-banco-da-felicidade.svg";
import { FiXCircle } from "react-icons/fi";
import { getUserData, getUserHistory } from "../controllers/userController";
import { getEmocionadores } from "../controllers/emocionarController";

const Header = styled.header`
  background: linear-gradient(185deg, ${Blue} 28%, ${Green} 0%);
  color: white;
  padding: 14px;
  padding-bottom: 28px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  gap: 18px;

  .headerText {
    margin-top: 18px;
    text-align: center;
    font-size: 18px;
    font-weight: normal;
  }
`;

const BackButton = styled.a`
  margin-top: 22px;
  display: flex;
  align-items: center;
  color: #fff;
  text-decoration: none;
  font-size: 20px;
  width: fit-content;
`;

const Employee = styled(Container)`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 30px;

  .employee-name {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: start;
    gap: 10px;
    text-align: left;

    h4 {
      color: #000;
      font-size: 14px;
      font-weight: 300;
    }
  }

  .employee-details {
    display: flex;
    flex-direction: column;
    justify-content: start;
    gap: 0px;
    flex: 1;
    text-align: left;
    p,
    small {
      color: #000;
      font-size: 14px;
      width: max-content;
    }

    p {
      font-weight: 500;
    }
    small {
      font-weight: lighter;
    }
  }

  .employee-icon-div {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 45px;
    height: 45px;
    border-radius: 50%;
    background-color: ${Border};
    text-align: center;
    padding: 10px;
  }
  .employee-icon {
    font-size: 25px;
    color: #444;
  }
`;

const MoedasTypeSelector = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 20px 0;
  padding: 0 20px;
  
  .selector-container {
    display: flex;
    background: #f0f0f0;
    border-radius: 25px;
    padding: 4px;
    width: 100%;
    max-width: 400px;
    border: 1px solid #e0e0e0;
  }
  
  .selector-btn {
    padding: 10px 20px;
    border: none;
    cursor: pointer;
    font-size: 12px;
    font-weight: 500;
    border-radius: 21px;
    transition: all 0.3s ease;
    flex: 1;
    text-align: center;
    
    &.active {
      background: #4CAF50;
      color: white;
      box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    }
    
    &.inactive {
      background: transparent;
      color: #666;
    }
  }
`;

const CoinSelection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
`;

const CoinItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 400px;
  border: 1px solid ${Border};
  border-radius: 25px;
  position: relative;
  padding: 10px 15px 10px 35px;

  img {
    position: absolute;
    left: -20px;
    width: 50px;
  }

  p {
    color: #444;
    text-align: center;
    min-width: 40px;
  }

  div {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  div span {
    font-size: 16px;
    color: #444;
    text-align: center;
    min-width: 30px;
  }

  @media screen and (max-width: ${breakpoints.sm}) {
    padding: 8px 12px 8px 30px;
  }
`;

const CoinButton = styled.button`
  background: none;
  color: #444;
  border: none;
  padding: 10px;
  font-size: 16px;
  cursor: pointer;

  &:hover {
    background: none !important;
  }
`;

const ContinueButton = styled.button`
  background-color: ${Green};
  padding: 10px 70px;
  border-radius: 30px;
  border: none;
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  cursor: pointer;

  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;

function SelecionarMoedasAdm({
  emocionador,
  onConfirm,
  onBack,
  onClose,
  errorMessage,
}) {
  const [selectedMoedas, setSelectedMoedas] = useState({
    1: 0,
    5: 0,
    10: 0,
    50: 0,
    100: 0,
  });
  
  const [allMoedasData, setAllMoedasData] = useState({});
  const [moedasDistribuidas, setMoedasDistribuidas] = useState({});
  const [moedasType, setMoedasType] = useState('Moedas Minha Equipe');
  const [receptorData, setReceptorData] = useState({});
  const [hasTimeStructure, setHasTimeStructure] = useState(false);
  const [loading, setLoading] = useState(true);

  const user = JSON.parse(localStorage.getItem("user")) || {};

  const handleMoedaChange = (value, amount) => {
    const currentSelected = selectedMoedas[value];
    const newValue = currentSelected + amount;

    if (newValue < 0) return;

    setSelectedMoedas({
      ...selectedMoedas,
      [value]: newValue,
    });
  };

  const canContinue = Object.values(selectedMoedas).some(
    (amount) => amount > 0
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setMoedasType('Moedas Minha Equipe');
        setSelectedMoedas({ 1: 0, 5: 0, 10: 0, 50: 0, 100: 0 });

        if (!emocionador?.id) {
          setLoading(false);
          return;
        }

        let receptorInfo = await getUserData(emocionador.id);

        if (Array.isArray(receptorInfo) && receptorInfo.length > 0) {
          receptorInfo = receptorInfo[0];
        }

        setReceptorData(receptorInfo || {});

        // 1. VERIFICAÇÃO DE CARGO
        const cargo = receptorInfo.cargo ? receptorInfo.cargo.trim() : "";
        
        const isGestor = cargo === "Gestor" 
        // 2. PARSE DO JSON
        let rawData = {};
        if (receptorInfo?.moedas_a_distribuir) {
            rawData = typeof receptorInfo.moedas_a_distribuir === "string"
            ? JSON.parse(receptorInfo.moedas_a_distribuir)
            : receptorInfo.moedas_a_distribuir;
        }

        const cleanData = {
             'Moedas Minha Equipe': { "1": 0, "5": 0, "10": 0, "50": 0, "100": 0 },
             'Moedas Outras Unidades': { "1": 0, "5": 0, "10": 0, "50": 0, "100": 0 }
        };

        const valores = ["1", "5", "10", "50", "100"];

        if (isGestor) {
            // ========================================================
            // LÓGICA PARA GESTORES (Com Botões)
            // ========================================================
            
            // 1. Processa chaves legadas e novas para "Minha Equipe"
            if (rawData["time"]) {
                valores.forEach(v => cleanData["Moedas Minha Equipe"][v] += Number(rawData["time"][v] || 0));
            }
            if (rawData["Moedas Minha Equipe"]) {
                valores.forEach(v => cleanData["Moedas Minha Equipe"][v] += Number(rawData["Moedas Minha Equipe"][v] || 0));
            }

            // 2. Processa chaves legadas e novas para "Outras Unidades"
            if (rawData["hotel"]) {
                valores.forEach(v => cleanData["Moedas Outras Unidades"][v] += Number(rawData["hotel"][v] || 0));
            }
            if (rawData["Moedas Outras Unidades"]) {
                valores.forEach(v => cleanData["Moedas Outras Unidades"][v] += Number(rawData["Moedas Outras Unidades"][v] || 0));
            }

            // 3. (AQUI ESTÁ O QUE VOCÊ PEDIU)
            // Pega as moedas da RAIZ e joga em "Moedas Minha Equipe"
            valores.forEach(valor => {
                if (rawData[valor] !== undefined) {
                    const valorRaiz = Number(rawData[valor]);
                    cleanData["Moedas Minha Equipe"][valor] += valorRaiz;
                }
            });

        } else {
            // ========================================================
            // LÓGICA PARA NÃO GESTORES (Sem Botões - Tudo Junto)
            // ========================================================
            // Ignora a separação de pastas e soma tudo o que encontrar na visualização padrão
            
            valores.forEach(valor => {
                let valorTotal = 0;
                
                // Soma da raiz
                if (rawData[valor] !== undefined) valorTotal += Number(rawData[valor]);
                
                // Soma de qualquer pasta que exista por engano
                if (rawData["Moedas Minha Equipe"] && rawData["Moedas Minha Equipe"][valor]) valorTotal += Number(rawData["Moedas Minha Equipe"][valor]);
                if (rawData["time"] && rawData["time"][valor]) valorTotal += Number(rawData["time"][valor]);
                if (rawData["hotel"] && rawData["hotel"][valor]) valorTotal += Number(rawData["hotel"][valor]);

                // Joga tudo na chave padrão
                cleanData["Moedas Minha Equipe"][valor] = valorTotal;
            });
        }

        setAllMoedasData(cleanData);
        setHasTimeStructure(isGestor);
        setMoedasDistribuidas(cleanData['Moedas Minha Equipe']);

      } catch (error) {
        toast.error("Erro ao carregar dados. Tente novamente.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [emocionador?.id]);

  useEffect(() => {
    if (allMoedasData && allMoedasData[moedasType]) {
        setMoedasDistribuidas(allMoedasData[moedasType]);
    }
  }, [moedasType, allMoedasData]);

  if (!emocionador) {
    return (
      <Container direction="column" width="100%">
        <ContentSection fullWidth padding="10px">
          <Content padding="20px" style={{ textAlign: 'center' }}>
            <p>Nenhum emocionador selecionado.</p>
          </Content>
        </ContentSection>
      </Container>
    );
  }

  if (loading) {
    return (
      <Container direction="column" width="100%">
        <ContentSection fullWidth padding="10px">
          <Content padding="20px" style={{ textAlign: 'center' }}>
            <p>Carregando dados...</p>
          </Content>
        </ContentSection>
      </Container>
    );
  }

  return (
    <>
      <Header>
        <h1 className="headerText">Distribuir</h1>
        <BackButton onClick={onClose}>
          <FiXCircle />
        </BackButton>
      </Header>
      <Container direction="column" width="100%" padding="10px">
        <ContentSection fullWidth>
          <Content bgColor={Accent} align="center" gap="30px">
            <Employee fullWidth padding="0px">
              <div className="employee-name">
                <div className="employee-icon-div">
                  <FaRegUserCircle className="employee-icon" />
                </div>
                <h4>{emocionador.nome}</h4>
              </div>
              <div className="employee-details">
                <p>{emocionador.unidade}</p>
                <small>{emocionador.setor}</small>
              </div>
            </Employee>

            {/* Seletor APENAS para Gestores */}
            {hasTimeStructure && (
             <MoedasTypeSelector>
                <div className="selector-container">
                  <button
                    className={
                      moedasType === "Moedas Minha Equipe"
                        ? "selector-btn active"
                        : "selector-btn inactive"
                    }
                    onClick={() => {
                        setMoedasType("Moedas Minha Equipe");
                        setSelectedMoedas({ 1: 0, 5: 0, 10: 0, 50: 0, 100: 0 });
                    }}
                  >
                    Moedas Minha Equipe
                  </button>
                  
                  <button
                    className={
                      moedasType === "Moedas Outras Unidades"
                        ? "selector-btn active"
                        : "selector-btn inactive"
                    }
                    onClick={() => {
                        setMoedasType("Moedas Outras Unidades");
                        setSelectedMoedas({ 1: 0, 5: 0, 10: 0, 50: 0, 100: 0 });
                    }}
                  >
                    Moedas Outras Unidades
                  </button>
                </div>
              </MoedasTypeSelector>
            )}

            <div style={styles.moedasSection}>
              {/* Título Dinâmico */}
              <p style={styles.sectionTitle}>
                {hasTimeStructure 
                  ? `${moedasType === 'Moedas Minha Equipe' ? 'Moedas Minha Equipe' : 'Moedas Outras Unidades'} (${emocionador.nome}):`
                  : `Moedas a distribuir:` 
                }
              </p>
              <div style={styles.moedasContainer}>
                <div style={styles.moedaItem}>
                  <img src={coin1} alt="1 Moeda" style={styles.moedaIcon} />
                  <p style={styles.moedaText}>{moedasDistribuidas["1"] || 0}</p>
                </div>
                <div style={styles.moedaItem}>
                  <img src={coin5} alt="5 Moedas" style={styles.moedaIcon} />
                  <p style={styles.moedaText}>{moedasDistribuidas["5"] || 0}</p>
                </div>
                <div style={styles.moedaItem}>
                  <img src={coin10} alt="10 Moedas" style={styles.moedaIcon} />
                  <p style={styles.moedaText}>{moedasDistribuidas["10"] || 0}</p>
                </div>
                <div style={styles.moedaItem}>
                  <img src={coin50} alt="50 Moedas" style={styles.moedaIcon} />
                  <p style={styles.moedaText}>{moedasDistribuidas["50"] || 0}</p>
                </div>
                <div style={styles.moedaItem}>
                  <img src={coin100} alt="100 Moedas" style={styles.moedaIcon} />
                  <p style={styles.moedaText}>{moedasDistribuidas["100"] || 0}</p>
                </div>
              </div>
            </div>

            <CoinSelection>
              {Object.entries(selectedMoedas).map(([value, amount]) => (
                <CoinItem key={value}>
                  <img
                    src={
                      value === "1" ? coin1 :
                      value === "5" ? coin5 :
                      value === "10" ? coin10 :
                      value === "50" ? coin50 : coin100
                    }
                    alt={`${value} Moedas`}
                  />
                  <p></p>
                  <div>
                    <CoinButton onClick={() => handleMoedaChange(value, -1)}>
                      -
                    </CoinButton>
                    <span>{amount}</span>
                    <CoinButton onClick={() => handleMoedaChange(value, +1)}>
                      +
                    </CoinButton>
                  </div>
                </CoinItem>
              ))}
            </CoinSelection>

            {errorMessage && (
              <ErrorComponent message={errorMessage} duration={8000} />
            )}
            <ContinueButton
              onClick={() => {
                onConfirm(selectedMoedas, moedasType);
              }}
              disabled={!canContinue}
            >
              Continuar
            </ContinueButton>
          </Content>
        </ContentSection>
      </Container>
    </>
  );
}

export default SelecionarMoedasAdm;